import SavingsCalculator from './SavingsCalculator'
import ModelGrid from './ModelGrid'
import WorldMap from './WorldMap'
import Wrap from '../ui/Wrap'
import Button from '../ui/Button'
import { Display, Statement, Body, Note, Accent, Em } from '../ui/Type'

export default function Guarantee({ onBurnChange }) {
  return (
    <section id="savings" className="bg-[#0A0A0A] py-24 text-[#F5F5F3] md:py-36">
      <Wrap>
        <Note tone="dark" className="uppercase">Cost &middot; Guarantees</Note>
        <Display tone="dark" className="mt-8 max-w-[18ch]">
          Know your AI economics before demand takes off.
        </Display>
        <Body tone="dark" className="mt-8 max-w-[560px]">
          Model what happens as AI usage scales across agents, workflows, users, and context. See how quickly metered
          inference compounds &mdash; and what predictable intelligence capacity could change.
        </Body>

        <SavingsCalculator onBurnChange={onBurnChange} />

        <Statement tone="dark" className="mt-16 max-w-[24ch]">
          The goal isn't cheaper tokens. It's <Accent tone="dark">removing the token meter</Accent> from the workloads
          that matter.
        </Statement>
        <Body tone="dark" className="mt-8 max-w-[620px]">
          <Em tone="dark">LiquidBrain turns unpredictable inference consumption into predictable capacity</Em> &mdash;
          so AI usage can grow without forcing the business to ration intelligence.
        </Body>

        <ModelGrid />

        <div className="mt-14 flex flex-wrap gap-3.5">
          <Button tone="dark" variant="primary" href="#" data-reserve>
            Bring us your workload &rarr;
          </Button>
          <Button
            tone="dark"
            variant="ghost"
            href="mailto:sales@nexlayer.com?subject=Liquid%20Brain%20-%20talk%20to%20us"
            data-talk-to-us
          >
            Talk to an AI Solutions Engineer
          </Button>
        </div>

        <WorldMap />
      </Wrap>
    </section>
  )
}
